import React from 'react'
import { PolicyListCard } from '../PolicyListCard'
import { Grid } from '@material-ui/core'
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { NoPoliciesCard } from '../NoPoliciesCard';
import { isMobile } from 'react-device-detect';
import './ActivePoliciesList.scss';

export const ActivePoliciesList = ({policies}) => {
    const matches = useMediaQuery('(min-width:1150px)');
    const small = (matches && policies.length > 1) || isMobile 
    return (
        <Grid container spacing={4}>
            {policies.map((item, index) => <Grid className={`${isMobile ? 'padding-x-0' : ''}`} key={index} xs={12} md={small ? 6 : 12} item> 
                <PolicyListCard
                    small={small} 
                    key={index} 
                    insurance={item} />
                </Grid>)}
                {policies.length == 0 && <Grid xs={12} md={6} item> <NoPoliciesCard /> </Grid>}
        </Grid>
    )
}